import NoDataBanner from "components/common/NoDataBanner";
import Typography from "components/common/Typography";
import { fetchRecentlyViewedData } from "components/features/Corp/CorpUser.Slice";
import { useTranslate } from "hooks/useTranslate";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import RecentData from "./RecentData";
import "./RecentlyViewed.scss";

const RecentlyViewed = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const innCode = useAppSelector((state: any) => state.app.innCode);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const recentDataAPIRespose: any = useAppSelector((state) => state.CorpDashboard.recentlyViewedData);

  const { cmsPlan, propertyPlan, ...rest } = recentDataAPIRespose;
  const recentData = isCorp ? { cmsPlan, ...rest } : { cmsPlan, propertyPlan };
  const isRecentDataEmpty = isEmpty(recentData) || recentData?.errors;
  const dataLength = isRecentDataEmpty ? "no-data-banner" : "";

  useEffect(() => {
    dispatch(
      fetchRecentlyViewedData({
        ...(isCorp ? {} : { innCode })
      })
    );
  }, [innCode]);

  return (
    <div className="view-recent-data-component">
      <div className="view-recent-data-heading">
        <Typography variant={"body1"} showBold>
          {translate("common.recentlyViewed")}
        </Typography>
      </div>
      <div className={`view-recent-data-container ${dataLength}`}>
        {!isRecentDataEmpty ? (
          <>
            {Object.entries(recentData)?.map(([key, value]) => {
              return <RecentData key={key} keyCategory={key} dataList={value} />;
            })}
          </>
        ) : (
          <NoDataBanner noDataMessage={translate("common.noRecentlyViewedData")} />
        )}
      </div>
    </div>
  );
};
export default RecentlyViewed;
